<template>
    <b-card title="User">
        <b-card-text>
            <div class="pl-lg-4">
                <b-form
                    @submit.prevent="updateBasic()"
                    data-vv-scope="password"
                >
                    <b-form-group
                        id="fieldset-firstName"
                        label="First Name"
                        label-for="input-firstName"
                        label-class="font-weight-bold"
                    >
                        <b-form-input
                            id="input-firstName"
                            v-model="model.firstName"
                            name="firstName"
                            required
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-lastName"
                        label="Last Name"
                        label-for="input-lastName"
                        label-class="font-weight-bold"
                    >
                        <b-form-input
                            id="input-lastName"
                            v-model="model.lastName"
                            name="lastName"
                            required
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <user-roles
                        :all-roles="roles"
                        v-model="model.roles"
                        label-class="font-weight-bold"
                    ></user-roles>

                    <b-form-group
                        id="fieldset-permissions"
                        label="Permissions"
                        label-for="input-permissions"
                        label-class="font-weight-bold"
                    >
                        <permission-groups
                            v-model="model.permissions"
                            :options="permissions_list"
                        ></permission-groups>
                    </b-form-group>

                    <b-row>
                        <b-col>
                            <b-button
                                variant="primary"
                                @click="updateBasic()"
                                class="float-right"
                                :disabled="updatingBasic ? true : false"
                                >{{
                                    updatingBasic
                                        ? 'Saving Changes...'
                                        : 'Save Changes'
                                }}</b-button
                            >
                            <b-button
                                @click="deleteUser()"
                                v-if="user_permissions.includes('delete.users')"
                                class="float-right"
                                variant="warning"
                            >
                                Delete User
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </b-card-text>

        <b-card-text>
            <div class="pl-lg-4">
                <b-form @submit.prevent="updateEmail()" data-vv-scope="email">
                    <b-form-group
                        id="fieldset-email"
                        label="Email"
                        label-for="input-email"
                        label-class="font-weight-bold"
                    >
                        <b-form-input
                            id="input-email"
                            v-model="model.email"
                            name="email"
                            type="email"
                            required
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <b-row>
                        <b-col>
                            <b-button
                                variant="primary"
                                @click="updateEmail()"
                                class="float-right"
                                :disabled="updatingEmail ? true : false"
                                >{{
                                    updatingEmail
                                        ? 'Updating Email...'
                                        : 'Update Email'
                                }}</b-button
                            >
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </b-card-text>

        <b-card-text>
            <div class="pl-lg-4">
                <b-form
                    @submit.prevent="updatePassword()"
                    data-vv-scope="password"
                >
                    <b-form-group
                        id="fieldset-password"
                        label="Password"
                        label-for="input-password"
                        label-class="font-weight-bold"
                    >
                        <b-form-input
                            id="input-password"
                            v-model="model.password"
                            name="password"
                            type="password"
                            required
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-confirmPassword"
                        label="Confirm Password"
                        label-for="input-pconfirmPassword"
                        label-class="font-weight-bold"
                    >
                        <b-form-input
                            id="input-confirmPassword"
                            v-model="model.confirmPassword"
                            name="confirmPassword"
                            required
                            ref="password"
                            type="password"
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <b-row>
                        <b-col>
                            <b-button
                                variant="primary"
                                @click="updatePassword()"
                                class="float-right"
                                :disabled="updatingPassword ? true : false"
                                >{{
                                    updatingPassword
                                        ? 'Changing Password...'
                                        : 'Change Password'
                                }}</b-button
                            >
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </b-card-text>
    </b-card>
</template>
<script>
import PermissionGroups from '@/components/PermissionGroups'
import popupMixins from '@/mixins/popupMixins'
import UserRoles from '@/components/UserRoles'

import _ from 'lodash'

export default {
    name: 'edit-user',
    components: { UserRoles, PermissionGroups },
    mixins: [popupMixins],
    data() {
        return {
            tabIdx: 0,
            model: {
                id: 0,
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                confirmPassword: '',
                roles: [],
                permissions: [],
            },
            updatingBasic: false,
            updatingEmail: false,
            updatingPassword: false,
        }
    },
    computed: {
        roles() {
            return this.$store.state.roles.items
        },
        permissions_list() {
            return this.$store.state.permissions.permissions_list
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {
        model: {
            handler: function (val) {
                console.log('value', val)
            },
            deep: true,
        },
        '$store.state.users.user': function (user) {
            console.log('user-2', user)
            let {
                id,
                email,
                first_name: firstName,
                last_name: lastName,
                roles: userRoles,
                permissions,
            } = user
            let roles = [...userRoles].map(({ role: { name } }) => name)

            console.log('roles', roles)
            permissions = permissions.map(({ permission }) => permission)

            this.model = {
                id,
                email,
                firstName,
                lastName,
                roles,
                permissions,
            }
            console.log('model-2', this.model)
        },
    },

    methods: {
        updateBasic() {
            console.log('upfaying', this.model)
            this.updatingBasic = true
            this.rolesError = null
            this.$validator.validate('basic.*').then(valid => {
                if (valid) {
                    const {
                        id: userId,
                        firstName: first_name,
                        lastName: last_name,
                        roles,
                        permissions,
                    } = this.model

                    console.log('upfaying', permissions)

                    this.$store
                        .dispatch('users/updateBasicInfo', {
                            userId,
                            first_name,
                            last_name,
                            roles,
                            permissions,
                        })

                        .then(() => {
                            this.doToast('Success!', 'User Updated', 'success')
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.doToast(
                                'Error!',
                                error.response.data.error.message,
                                'danger'
                            )
                        })
                        .finally(() => {
                            this.updatingBasic = false
                        })
                } else {
                    this.updatingBasic = false
                }
            })
        },
        updateEmail() {
            this.updatingEmail = true
            this.$validator.validate('email.*').then(valid => {
                if (valid) {
                    const { id: userId, email } = this.model
                    this.$store
                        .dispatch('users/updateEmail', { userId, email })
                        .then(res => {
                            console.log(res)
                            this.doToast('Success!', 'Email Updated', 'success')
                        })
                        .catch(error => {
                            this.errors.add({
                                field: 'email',
                                msg: error.response.data.error.message,
                                scope: 'email',
                            })
                        })
                        .finally(() => {
                            this.updatingEmail = false
                        })
                } else {
                    this.updatingEmail = false
                }
            })
        },
        updatePassword() {
            this.updatingPassword = true
            this.$validator.validateAll('password').then(valid => {
                if (valid) {
                    console.log(this.model)
                    const { id: userId, password } = this.model
                    this.$store
                        .dispatch('users/updatePassword', { userId, password })
                        .then(() => {
                            this.doToast(
                                'Success!',
                                'Password Updated',
                                'success'
                            )
                        })
                        .finally(() => {
                            this.updatingPassword = false
                        })
                } else {
                    this.updatingPassword = false
                }
            })
        },

        async deleteUser() {
            // Initializing key variables
            const model = { ...this.model }
            const path = 'users/deleteUser'

            // Generate and display confirmation prompt
            const title = 'Delete User?'
            const message = `Are you sure you want to delete ${model.firstName}?`

            const result = await this.confirmMessage(title, message)
            if (result) {
                await this.$store
                    .dispatch(path, model.id)
                    .then(() => {
                        this.doToast(
                            'Deleted!',
                            'User has been successfully deleted.',
                            'success'
                        )
                    })
                    .catch(error => {
                        console.log('users', error)
                        this.doToast(
                            'Error!',
                            'Unable to delete user!',
                            'danger'
                        )
                    })
                    .finally(
                        _.debounce(() => {
                            this.$router.go(-1)
                        }, 1000)
                    )
            }
        },
    },
    mounted() {
        this.$store.dispatch('roles/fetch', {
            query: '',
            page: 1,
        })

        this.$store.dispatch('permissions/all')

        this.$store.dispatch('users/fetchUser', this.$route.params.id)
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
